import Typography from "@material-ui/core/Typography/Typography";
import React from "react";

const TabContainer = (props) => {
  return (
    <Typography component="div" style={{ padding: 8 * 3, height: "calc(100% - 48px)" }}>
      {props.children}
    </Typography>
  );
};

export default TabContainer;